module.exports = __webpack_public_path__ + "img/img-3-14.58e86a7e.webp";